import React from 'react'
import { connect } from 'react-redux'
import { LocalForm, Control, actions } from 'react-redux-form'
import Errors from './Errors'

import {
  update_preference
 } from '../actions'

const { toast, updateTextFields } = window.M

const mapStateToProps = state => {
  return {
    errors: state.preference.errors
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updatePreference: (preference_id, values) => dispatch( update_preference(preference_id, values) )
  }
}

class ConnectedPreferenceRowEdit extends React.Component {

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  cancel() {
    this.formDispatch(actions.reset('localPreference'));
    this.props.cancel()

    setTimeout(function(){
      updateTextFields()
    }, 150)
  }

  componentDidUpdate(prevProps, prevState) {
    const {preference} = this.props
    const previousPreference = prevProps.preference

    if (JSON.stringify(previousPreference) !== JSON.stringify(preference)) {
      toast({
        html: "Preference updated",
        displayLength: 1000,
        inDuration: 0
      })
      return this.cancel()
    }
  }

  componentDidMount() {
    setTimeout(function(){
      updateTextFields()
    }, 150)
  }

  handleSubmit(values) {
    const { preference } = this.props
    const { id } = preference
    this.props.updatePreference(id, values)
  }

  render() {
    const {showForm, preference, errors} = this.props;

    if (showForm === 'hide') {
      return ''
    }

    const rowClass = "inlineForm " + showForm.replace('hide','hidden')

    const {name, value, datatype } = preference

    const showErrors = (showForm === "") ? errors : []

    let controlText

    if ( datatype === "arithmetic" ) {
      controlText = <Control.text id="preference_value" model=".value" type="number"/>
    } else if ( datatype === "boolean" ) {
      controlText = <Control.checkbox id="preference_value" model=".value"/>
    } else {
      controlText = <Control.text id="preference_value" model=".value"/>
    }

    return (
        <tr className={rowClass}>

          <td colSpan={3}>
            <div>
              <LocalForm
              model="localPreference"
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              onSubmit = { (values) => {
                this.handleSubmit(values)
              }}
              initialState={{
                value: value
              }}
              >
                <div className="row inlineRow">
                  <div className="col xl10 l10 s12 row formRow">
                    <div className="input-field col s12 l12 xl12">
                      <label htmlFor="preference_value" className="active">{name}</label>
                      {controlText}
                    </div>
                  </div>

                  <div className="col xl2 l2 s12 formButtons setToRight">
                    <button className="btn-small btn-flat" title="Save"><i className="material-icons tiny c-light-green">save</i></button>
                    <a href='' className="btn-small btn-flat hover-red" title="Cancel" onClick={ e=> {
                      e.preventDefault()
                      this.cancel()
                    }}><i className="material-icons tiny c-red darken-1">cancel</i></a>
                  </div>
                </div>

              </LocalForm>

            </div>
            <Errors errors={showErrors}/>
          </td>

        </tr>

    )
  }

}

const PreferenceRowEdit = connect(mapStateToProps, mapDispatchToProps)(ConnectedPreferenceRowEdit)

export default PreferenceRowEdit



// WEBPACK FOOTER //
// ./src/js/components/PreferenceRowEdit.js